const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';
const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product-grid-item',
};

document.addEventListener('DOMContentLoaded', () => {
  initButtons();
  initGrid();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    // console.log("button from setupButtons",button)
    const productHandle = button.dataset.productHandle || false;
    const productType = button.dataset.productType || false;
    // console.log('productType',productType)
    // console.log("init productHandle",productHandle)
    if ((!productHandle) || (!productType)) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle+'_'+productType)){
      button.classList.add(BUTTON_ACTIVE_CLASS);
      button.querySelector('.icon-heart').classList.add('fa-solid')
      button.querySelector('.icon-heart').classList.remove('fa-regular')
      // to display add wishlist / remove wishlist
      try{
        let button_text = button.querySelector('.btn__inner').querySelector('.btn__text')
        button_text.innerText = "Remove Wishlist"
      }
      catch(err) {
      }

    } 
    button.addEventListener('click', () => {
      // e.preventDefault();
      // console.log('clicked')
      // to display add wishlist / remove wishlist
      const productHandle = button.dataset.productHandle || false;
      const productType = button.dataset.productType || false;
      updateWishlist(productHandle, button);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
      button.querySelector('.icon-heart').classList.toggle('fa-solid')
      button.querySelector('.icon-heart').classList.toggle('fa-regular')
      jQuery.getJSON('/products/'+productHandle+'.js', function(product) {
        console.log("product",product.featured_image);
        img_html = '<img src="'+product.featured_image+'" width="60px;">'
        document.querySelector('.wishlist-modal .wishlist-image').innerHTML = img_html;
        document.querySelector('.wishlist-modal').style.display = "block";
        setTimeout(function() {document.querySelector('.wishlist-modal').style.display = "none"}, 3000);
      })
      
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  // console.log("buttons",buttons)
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle, button) => {
  const wishlist = getWishlist();
  // console.log('wishlist',wishlist);
  var type = button.getAttribute('data-product-type')
  // console.log('type',type)
  const indexInWishlist = wishlist.indexOf(handle+'_'+type);
  if (indexInWishlist === -1) {
    wishlist.push(handle+'_'+type)
    // to display add wishlist / remove wishlist
    try{
      let button_text = document.querySelector('.wishlist-modal .wishlist-text')
      button_text.innerHTML = "Item Added!"
    }
    catch(err) {
    }
  }
  else {
    wishlist.splice(indexInWishlist, 1)
    try{
      let button_text = document.querySelector('.wishlist-modal .wishlist-text')
      button_text.innerHTML = "Item Removed!"
    }
    catch(err) {
    }

  }
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};